const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000',
    //API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://server.autojoaopires.pt',
};

export default config;
